module.exports = __webpack_public_path__ + "img/presale-detail12.90d0966f.png";